import { CitySearchFormModel } from '@cp/entities/location';
import { CatalogSortingTypes } from 'src/entities/catalog/model/types';
import { FormAvailableOnlyModel } from 'src/entities/catalog/ui/availableOnly/model';

export enum FormFieldName {
  Sorters = 'sorters',
}

export type FormModel = CitySearchFormModel &
  FormAvailableOnlyModel & {
    [Key in FormFieldName.Sorters]: CatalogSortingTypes;
  };

export type FormSubmitTrigger = () => Promise<void> | void;
